// ============================================================
// THE PSYKER'S SCRIPT (plan body-map T1; Voynich chosen by the user,
// 2026-10-09: a real, undeciphered script - "a wink that invites players to
// explore" - never an occult, religious or Nordic one). It has no Unicode,
// so its characteristic letters are drawn here, in a 100-unit box on a
// baseline at 78: the bowls o a e, the paired ch, the curls d y 8, the
// minims i n r, and the tall looped gallows.
// ============================================================

const VOYNICH = [
  'M36 62 a14 14 0 1 0 28 0 a14 14 0 1 0 -28 0',
  'M62 50 a14 14 0 1 0 0 24 M62 47 L62 78',
  'M60 52 a13 13 0 1 0 0 22',
  'M42 52 a11 11 0 1 0 0 22 M64 52 a11 11 0 1 0 0 22 M38 47 Q53 39 68 47',
  'M56 77 a13 13 0 1 1 5 -21 Q70 30 50 18',
  'M40 52 a12 12 0 1 0 22 7 Q66 92 44 98',
  'M50 40 a10 10 0 1 0 0 20 a12 12 0 1 1 0 24 a12 12 0 1 1 0 -24 a10 10 0 1 0 0 -20',
  'M34 78 L38 22 C40 9 57 10 52 27 C49 39 39 36 44 25 M52 27 L60 78 M26 79 Q50 71 74 79',
  'M30 78 L33 24 C35 11 48 12 45 27 M45 27 C52 12 66 13 62 28 C59 40 50 37 54 26 M62 28 L68 78 M24 79 Q50 71 78 79',
  'M38 78 L40 24 C42 10 58 12 54 28 M30 44 L70 44 M54 28 L60 78',
  'M44 76 L44 50 Q49 43 60 48',
  'M42 77 L42 54 Q42 47 50 49 M58 54 L58 78 Q58 87 67 85',
];

/** Letter `k` of the script (cycling), as a path. */
export const glyph = (k: number) => VOYNICH[k % VOYNICH.length];
